import TagManager from 'react-gtm-module';
import { useEffect, useRef } from 'react';

// https://github.com/alinemorelli/react-gtm?tab=readme-ov-file#environments
export interface GoogleTagManagerConfig {
  gtmId: string;
  dataLayer?: Record<string, unknown>;
  dataLayerName?: string;
  events?: Record<string, unknown>;
  auth?: string | undefined;
  preview?: string | undefined;
}

export function GoogleTagManager(config: GoogleTagManagerConfig) {
  const initializedRef = useRef(false);

  useEffect(() => {
    if (!config.gtmId || initializedRef.current) return;

    TagManager.initialize(config);
    initializedRef.current = true;
  }, [config]);

  return null;
}
